import type { components } from '@shared/types/generated/Crocotile.ts';
import type { Variation } from '@shared/types/types.ts';
import type { ProductTitle } from '@tile/components/product-title/ProductTitle.ts';

type Title = components['schemas']['Title'] | undefined;

/*                                                                                                 */
export function mapTitle(variation: Variation, hasTopInfos: boolean): ProductTitle {
    return {
        brand: variation.brand,
        display: resolveDisplayTitle(variation.title, hasTopInfos),
    };
}

/*                                                                         */
export function mapFashionTitle(variation: Variation): ProductTitle {
    return {
        brand: variation.brand,
        display: variation.title?.withoutBrand ?? '',
    };
}

/**
 *
 *
 */
export function mapShortTitle(variation: Variation): ProductTitle {
    return {
        brand: variation.brand,
        display: resolveDisplayTitle(variation.title, true),
    };
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
function resolveDisplayTitle(title: Title, hasTopInfos = false) {
    if (!title) return '';
    if (hasTopInfos && title.shortened) return title.shortened;
    return title.withoutBrand ?? '';
}
